<div class="h-100 bc-mono-white" style="overflow: hidden;">
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <ui-kit-svg class="logo-left" name="bc-logo"></ui-kit-svg>
    <ui-kit-svg class="logo-right" name="bc-logo"></ui-kit-svg>
</div>

<vue-widget domain="https://kenes.1414.kz"></vue-widget>
